import { AgentCertificate } from './agent-certificate.model';
import { AgentCurrency } from './agent-currency.model';
import { AgentRepresentative } from './agent-representative.model';
import { BaseUserDto } from 'src/app/shared/models/base-user.model';

export class AgentInfo {
    RegisterTypeId: number;
    UserId: string;
    Name: string;
    DisplayName: string;
    Address: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    ContactPerson: string;
    IsOffline: boolean;
    IsActive: boolean;
    IsExpiredDueFees: boolean;
    IsExpiredDueCertificate: boolean;
    MainTreasuryNumber: string;
    DeactivationDate: Date;
    IsDeleted: boolean;
    CreationDate: Date;
    ModifiedDate: Date;
    CreatedBy: string;
    ModifiedBy: string;
    MoreInformation: string;
    IsPaymentConfirmed: boolean;
    AgentCertificates: AgentCertificate[] = [];
    AgentCurrencies: AgentCurrency[] = [];
    AgentRepresentatives: AgentRepresentative[] = [];
    ActivationCode: string;
    ConfirmationCode: string;
    /* Added in Ebooking-Revamp */
    GuaranteeType?: number;
    MaxValueNetTonnage?: number;
    MaxValueNetTonnageUnit?: number;
    // BaseUser: BaseUserDto = new BaseUserDto();
}